import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLkw = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={27} fill="none" {...props}>
    <path fill="#B3B3B3" fillRule="evenodd" d="M10 .5h22v22h-4a4 4 0 0 1-8 0h-8a4 4 0 0 1-8 0H0v-10a6 6 0 0 1 6-6h4zm0 10v4H4v-4z" clipRule="evenodd" />
  </svg>
);
export default SvgLkw;
